import React, { BaseSyntheticEvent, ReactChildren } from 'react';
import Link, { LinkProps } from 'housecall-ui/dist/DesignSystem/Navigation/Link/Link';
import { isBlank } from 'utils/isBlank';

import { useTrackEventsService } from 'components/Services/Analytics/useTrackEventsService';

type Props = {
  children?: ReactChildren | string;
  linkLabel?: string;
  onClick?: (event?: BaseSyntheticEvent) => void;
  href: string;
} & LinkProps;

const TrackedLink = ({ linkLabel = '', onClick, ...rest }: Props) => {
  const { trackLinkClicked } = useTrackEventsService();

  let label = linkLabel;

  if (typeof rest.children === 'string' && isBlank(linkLabel)) {
    label = rest.children;
  }

  const handleClick = (event: BaseSyntheticEvent) => {
    trackLinkClicked({ label, clickUrl: rest.href });
    onClick?.(event);
  };
  return <Link data-testid="tracked-link" onClick={handleClick} {...rest} />;
};
export default TrackedLink;
